import React from "react";

import type { SubscriptionMobilePricingProps } from "./types";
import PurchaseActions from "@/src/components/Member/Subscription/SubscriptionCard/PurchaseActions";
import type {
  BillingCycleType,
  PurchaseActionsProps,
} from "@/src/components/Member/Subscription/types";
import { SubscribableTerms } from "../Subscription/SubscriptionCardH5/CardList/SubscribableTerms";
import { cn, deviceDetector } from "utils";

interface SubscriptionMobilePricingFooterProps {
  ctaMode: "hidden" | "current" | "action";
  ctaText: string;
  selectedPlan?: PurchaseActionsProps["plan"];
  selectedBillingCycle?: BillingCycleType;
  isLoading?: boolean;
  isPaying: boolean;
  isTrial?: boolean;
  trialList?: SubscriptionMobilePricingProps["trialList"];
  userPlanInfo?: SubscriptionMobilePricingProps["userPlanInfo"];
  onStripeClick?: PurchaseActionsProps["onStripeClick"];
  onAppPurchaseSuccess?: SubscriptionMobilePricingProps["onAppPurchaseSuccess"];
  // 由 CTA 矩阵计算得到，透传给 PurchaseActions 控制 crypto 行展示。
  showCrypto: boolean;
}

export const SubscriptionMobilePricingFooter: React.FC<
  SubscriptionMobilePricingFooterProps
> = ({
  ctaMode,
  ctaText,
  selectedPlan,
  selectedBillingCycle,
  isLoading,
  isPaying,
  isTrial,
  trialList,
  userPlanInfo,
  onStripeClick,
  onAppPurchaseSuccess,
  showCrypto,
}) => {
  const hasPlanSelection = !!selectedPlan;

  // Footer 渲染优先级：
  // 1) hidden 或无 plan -> 统一占位；
  // 2) 其余 -> 走 PurchaseActions 主流程（billingCycle 可选）。
  return (
    <div
      className={cn(
        "shrink-0 bg-background_solid_secondary pt-3",
        deviceDetector.isH5() && "pb-4",
      )}
    >
      {ctaMode === "hidden" || !hasPlanSelection || !userPlanInfo ? (
        <div className="h-11" />
      ) : (
        <PurchaseActions
          isFree={false}
          isLoading={isLoading || isPaying}
          userPlanInfo={userPlanInfo}
          trialList={trialList}
          isH5={true}
          onAppPurchaseSuccess={onAppPurchaseSuccess}
          disableInvisiblePlaceholder={true}
          hidePaymentIcons={true}
          billingCycle={selectedBillingCycle}
          plan={selectedPlan}
          isTrial={isTrial}
          onStripeClick={onStripeClick}
          buttonTitleOverride={ctaText}
          forceButtonDisabled={ctaMode === "current"}
          showCryptoOverride={showCrypto}
        />
      )}
      <SubscribableTerms />
    </div>
  );
};
